
var userSlip = {};
var combinations;
var quotes;
var ticketAmount;
var matchCount = 0;
var selectedSystem = 0;

module.exports = {
    addToSlip: function (playId, homeTeam, awayTeam, odd, betType, betCode, elem) {

        ticketAmount = parseFloat($('#slip-btn').val()).toFixed();
        // do not allow more than 10 matches to select
        if (Object.keys(userSlip).length > 9) {
            return;
        }

        highlightSelected(elem);
        userSlip[playId + "|" + betCode] = {
            'homeTeam' : homeTeam,
            'awayTeam' : awayTeam,
            'odd' : parseFloat(odd).toFixed(2),
            'betType' : betType,
            'betCode' : betCode
        };

        matchCount = this.getUniqueMatches().length;
        selectedSystem = Object.keys(userSlip).length;
        loadSlip(userSlip);
        updateSystem(this.getUniqueMatches());
        recalculate();
        $('#slipGamesCounter').text(Object.keys(userSlip).length)

    },
    getUniqueMatches: function(){

        let counter = [];

        if( Object.keys(userSlip).length > 0) {
            Object.keys(userSlip).map((item) => {
                let matchId = item.slice(0, (item.length - userSlip[item].betCode.length) - 1);
                return counter.push(matchId);
            });
        }
        let unique = counter.filter((v, i, a) => a.indexOf(v) === i);

        return unique;
    },
    removeFromSlip: function (playId, betCode) {

        delete userSlip[playId + "|" + betCode];
        matchCount = this.getUniqueMatches().length;
        selectedSystem = 0;
        $('*[data-betcode="'+betCode+'"]', $('*[data-id="'+playId+'"]')).removeClass('gt-odds-active');
        loadSlip(userSlip);
        updateSystem(this.getUniqueMatches());
        recalculate();
        $('#slipGamesCounter').text(Object.keys(userSlip).length)
        
    },
    selectSystem: function (elem) {
        if(elem.is(':checked') !== true) {
            $('.styled-checkbox').prop('checked', false);
            elem.prop('checked', false);
            $('.slip-systems').removeClass('active');
            selectedSystem = Object.keys(userSlip).length;
        } else {
            $('.styled-checkbox').prop('checked', false);
            elem.prop('checked', true);
            selectedSystem = elem.val();
        }

        recalculate();
    },
    setBetValue : function(val){
        $('#slip-btn').val(parseFloat(val).toFixed(2));
        ticketAmount = parseFloat(val).toFixed(2);
        $('#total-stake').text(ticketAmount);
        recalculate();
    },
    slipValueUp : function(){
        let input = $('#slip-btn');
      if (input !== undefined) {
        let value = $(input).val();
        let max = $(input).attr('max');
        if (value !== undefined && max !== undefined) {
          value = parseFloat(value.toString());
          let step = $(input).attr('step');
          if (step !== undefined) {
             if(value + parseFloat(step) <= parseFloat(max)) {
               $(input).val((value + parseFloat(step)).toFixed(2));
               ticketAmount = (value + parseFloat(step)).toFixed(2);
            } else {
             $(input).val(parseFloat(max).toFixed(2)); 
             ticketAmount = parseFloat(max).toFixed(2);
            }
            $('#total-stake').text(ticketAmount);
            recalculate();
          }
        }
      }
  },
  slipValueDown : function(){
      let input = $('#slip-btn');
      if (input !== undefined) {
        let value = $(input).val();
        let min = $(input).attr('min');
        if (value !== undefined && min !== undefined) {
          value = parseFloat(value.toString());
          let step = $(input).attr('step');
          if (step !== undefined) {
            if(value - parseFloat(step) > parseFloat(min)) {
              $(input).val((value - parseFloat(step)).toFixed(2));
              ticketAmount = (value - parseFloat(step)).toFixed(2);
            } else {
              $(input).val(parseFloat(min).toFixed(2)); 
              ticketAmount = parseFloat(min).toFixed(2);
            }
            $('#total-stake').text(ticketAmount);
            recalculate();
          }
        }
      }
  },
  getSlip : function(){
      return userSlip;
  },
  getBettingData : function(){
      bettingData = {
          system : selectedSystem,
          ticketAmount : ticketAmount,
          combinations : combinations
      };

      return bettingData;
  },
  emptySlip : function(){
      $('.bet-choose').removeClass('gt-odds-active');
      userSlip = {};
      loadSlip(userSlip);
      $('#slipGamesCounter').text(0)
  }

};

function loadSlip(userSlip){
    $('#slip-matches').html('');
    var totalOdd = 0;
    $.each( userSlip, function( key, value ) {
        $('#slip-matches').append(slipHtml(value.homeTeam, value.awayTeam, key, value.odd, value.betType, value.betCode));
        totalOdd = totalOdd > 0 ? totalOdd * parseFloat(value.odd) : parseFloat(value.odd);
    });
    $('#total-odd').html(totalOdd.toFixed(2));
}

function highlightSelected(elem){
    let parent = elem.parent().parent().parent();
    gameId = parent.data('id');
    gameHolder = $('*[data-id="'+gameId+'"]');
    elem.removeClass('gt-odds-active');
    //$('.bet-choose', gameHolder).removeClass('gt-odds-active');
    elem.addClass('gt-odds-active');
}

function slipHtml(homeTeam, awayTeam, matchId, odd, betType, betCode){

    let html = '<div class="slip-bar">'+
            '<div class="virtualf-team-holder">'+
                '<div class="team-home">'+homeTeam+'</div>-<div class="team-away">'+awayTeam+'</div>'+
            '</div>'+
            '<div class="virtualf-result-holder">'+betType+'</div>'+
            '<div class="virtualf-odds-holder">'+odd+'</div>'+
            '<div class="slip-x" data-matchid="'+matchId+'" data-betCode="'+betCode+'">✖</div>'+
        '</div>';

        return html;
}

function countDuplicateMatches() {
    let counts = {};
    let matchIds = [];

    if( Object.keys(userSlip).length > 0) {
        Object.keys(userSlip).map((item) => {
            let matchId = item.slice(0, (item.length - userSlip[item].betCode.length) - 1);
            return matchIds.push(matchId);
        });
    }

    matchIds.map(x => counts[x] = (counts[x] || 0)+1 );
    return counts;
}

function areDuplicatedMatches(){
    let duplicated = Object.values(countDuplicateMatches()).some(el => el > 1);
    return duplicated;
}

function updateSystem(uniqueMatch){

    $('.styled-checkbox').prop('disabled', true);
    $('.styled-checkbox').prop('checked', false);

    if (areDuplicatedMatches()) {

        $('.slip-systems').addClass('active');
        $('#styled-checkbox-1').prop('disabled', false);

        if($('#styled-checkbox-1').is(':checked') !== true) {

            $('#styled-checkbox-1').prop('checked', true);
            selectedSystem = $('#styled-checkbox-1').val();
        } else {
            $('#styled-checkbox-1').prop('checked', false);
            $('.slip-systems').removeClass('active');
            selectedSystem = Object.keys(userSlip).length;
        }
        recalculate();
    }

    if (uniqueMatch.length > 0) {
        $('.slip-systems').addClass('active');

        uniqueMatch.map( (key, val) => {
            let id = parseInt(val);
            $('#styled-checkbox-'+id).prop('disabled', false);
        });

    } else {
        $('.slip-systems').removeClass('active');
    }
}

function getQuotes(){
    quotes = [];
    $.each( userSlip, function( key, value ) {
        quotes.push(value.odd)
    });

    return quotes;
}

function recalculate(){
  maxWin = "0.00";

  if(selectedSystem > 0){
     maxWin = calcCombination(ticketAmount, getQuotes(), selectedSystem );
  } else {
    maxWin = calcMaximalWin(ticketAmount, getQuotes())
  }

  combinations = factorial(Object.keys(userSlip).length) / (factorial(selectedSystem) * factorial(Object.keys(userSlip).length - selectedSystem));

  var combinationsText = combinations;
  var systemText =  parseInt(selectedSystem) > 0 ? selectedSystem : '-';
  $('#system').text(systemText);
  $('#combinations').text(combinationsText);
  $('#max-win-amount').text(maxWin.toFixed(2));

}

function factorial(n) {
    return(n<2)?1:factorial(n-1)*n;
}

function calcMaximalWin(ticketAmount, quotesArr) {
    var totalQuote = 0;
    for (var i = 0; i < quotesArr.length; i++) {
        totalQuote = totalQuote > 0 ? totalQuote * parseFloat(quotesArr[i]) : parseFloat(quotesArr[i]);
    }

    return totalQuote * ticketAmount > parseInt(window.MaxWin) ? window.MaxWin : totalQuote * ticketAmount;
}

function calcCombination(ticketAmount, arr_odds, combDepth) {
    // Broj kvota u nizu
    var itemCount = arr_odds.length;
    
    combDepth = parseInt(combDepth);
    // Ako je broj meceva veci ili jednak broju combDepth
    if (parseInt(itemCount) >= parseInt(combDepth)) { 
        // Racunanje broja kombinacija 
        var n = 1;
        for (var i = (combDepth + 1); i < (itemCount + 1); i++) {
            n = n * i;
        }

        var k = 1;
        for (var i = 2; i < (itemCount - combDepth + 1); i++) {
            k = k * i;
        }

        var combCount = n / k;

        // Racunanje uplate po kombinaciji
        var amountPerComb = ticketAmount / combCount;

        // Racunanje maxWin
        var winMoney = 0;

        switch(combDepth) {
            case 1:
                for (var m1 = 0; m1 < itemCount; m1++) {
                    winMoney = winMoney + amountPerComb * arr_odds[m1];
                }
                break;
            case 2:
                for (var m1 = 0; m1 < (itemCount - 1); m1++) {
                    for (var m2 = m1 + 1; m2 < itemCount; m2++) {
                        winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2];
                    }
                }
                break;
            case 3:
                for (var m1 = 0; m1 < (itemCount - 2); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 1); m2++) {
                        for (var m3 = m2 + 1; m3 < itemCount; m3++) {
                            winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3];
                        }
                    }
                }
                break;
            case 4:
                for (var m1 = 0; m1 < (itemCount - 3); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 2); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 1); m3++) {
                            for (var m4 = m3 + 1; m4 < itemCount; m4++) {
                                winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4];
                            }
                        }
                    }
                }
                break;
            case 5:
                for (var m1 = 0; m1 < (itemCount - 4); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 3); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 2); m3++) {
                            for (var m4 = m3 + 1; m4 < (itemCount - 1); m4++) {
                                for (var m5 = m4 + 1; m5 < itemCount; m5++) {
                                    winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5];
                                }
                            }
                        }
                    }
                }
                break;
            case 6:
                for (var m1 = 0; m1 < (itemCount - 5); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 4); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 3); m3++) {
                            for (var m4 = m3 + 1; m4 < (itemCount - 2); m4++) {
                                for (var m5 = m4 + 1; m5 < (itemCount - 1); m5++) {
                                    for (var m6 = m5 + 1; m6 < itemCount; m6++) {
                                        winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6];
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case 7:
                for (var m1 = 0; m1 < (itemCount - 6); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 5); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 4); m3++) {
                            for (var m4 = m3 + 1; m4 < (itemCount - 3); m4++) {
                                for (var m5 = m4 + 1; m5 < (itemCount - 2); m5++) {
                                    for (var m6 = m5 + 1; m6 < (itemCount - 1); m6++) {
                                        for (var m7 = m6 + 1; m7 < itemCount; m7++) {
                                            winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7];
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case 8:
                for (var m1 = 0; m1 < (itemCount - 7); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 6); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 5); m3++) {
                            for (var m4 = m3 + 1; m4 < (itemCount - 4); m4++) {
                                for (var m5 = m4 + 1; m5 < (itemCount - 3); m5++) {
                                    for (var m6 = m5 + 1; m6 < (itemCount - 2); m6++) {
                                        for (var m7 = m6 + 1; m7 < (itemCount - 1); m7++) {
                                            for (var m8 = m7 + 1; m8 < itemCount; m8++) {
                                                winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7] * arr_odds[m8];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case 9:
                for (var m1 = 0; m1 < (itemCount - 8); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 7); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 6); m3++) {
                            for (var m4 = m3 + 1; m4 < (itemCount - 5); m4++) {
                                for (var m5 = m4 + 1; m5 < (itemCount - 4); m5++) {
                                    for (var m6 = m5 + 1; m6 < (itemCount - 3); m6++) {
                                        for (var m7 = m6 + 1; m7 < (itemCount - 2); m7++) {
                                            for (var m8 = m7 + 1; m8 < (itemCount - 1); m8++) {
                                                for (var m9 = m8 + 1; m9 < itemCount; m9++) {
                                                    winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7] * arr_odds[m8] * arr_odds[m9];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                break;
            case 10:
                for (var m1 = 0; m1 < (itemCount - 9); m1++) {
                    for (var m2 = m1 + 1; m2 < (itemCount - 8); m2++) {
                        for (var m3 = m2 + 1; m3 < (itemCount - 7); m3++) {
                            for (var m4 = m3 + 1; m4 < (itemCount - 6); m4++) {
                                for (var m5 = m4 + 1; m5 < (itemCount - 5); m5++) {
                                    for (var m6 = m5 + 1; m6 < (itemCount - 4); m6++) {
                                        for (var m7 = m6 + 1; m7 < (itemCount - 3); m7++) {
                                            for (var m8 = m7 + 1; m8 < (itemCount - 2); m8++) {
                                                for (var m9 = m8 + 1; m9 < (itemCount - 1); m9++) {
                                                    for (var m10 = m9 + 1; m10 < itemCount; m10++) {
                                                        winMoney = winMoney  + amountPerComb * arr_odds[m1] * arr_odds[m2] * arr_odds[m3] * arr_odds[m4] * arr_odds[m5] * arr_odds[m6] * arr_odds[m7] * arr_odds[m8] * arr_odds[m9] * arr_odds[m10];
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
        }

        return winMoney > parseInt(window.MaxWin) ? window.MaxWin : winMoney;
    } else {
        return 0;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/ticket/slip.js
// module id = 323
// module chunks = 4